import React from "react";
import "./SupportModal.scss"
import { Popup } from "witmeg-ui-system";
import close from "../../../assets/close.svg"
import phone from "../../../assets/phone-line.svg"

import { useSelector } from "react-redux";

const SupportModal = ({ visibility, onClose }) => {
    const companyDetails = useSelector((state) => state.companyData.company)

    return (
        <Popup
            className='SupportModal'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={onClose}
            closable={false}>
            <div className="modal-inner">
                <div className="modal-inner-header-container">
                    <div className="modal-inner-header-wrapper">
                        <div className="modal-inner-title-text">
                            Contact Support
                        </div>
                        <img className="close-icon" alt="" src={close}
                            onClick={onClose} />
                    </div>
                </div>
                <div className="modal-inner-container">
                    <div className="center-text-container">
                        <div className="center-text-container-hdr">
                            Our support team is available 24/7 to assist you
                        </div>
                        <div className="center-text-container-sub">
                            Response time: <span>Under 2 minutes</span>
                        </div>
                    </div>
                    <div className="contact-detil-cont">
                        <div className="contact-detil-cont-hdr">
                            Main Support Line
                        </div>
                        <div className="contact-detil-cont-wrap">
                            <div className="contact-detil-cont-wrap-left">
                                <div className="contact-detil-cont-wrap-left-sub">
                                    For general inquiries and order support
                                </div>
                                <div className="contact-detil-cont-wrap-left-num">
                                    +44 {companyDetails?.Phone}
                                </div>
                            </div>
                            <div className="contact-detil-cont-wrap-bubble">
                                <img alt="" src={phone} />
                            </div>
                        </div>
                    </div>
                    <div className="center-text-container">
                        <div className="center-text-container-hdr">
                            You can also reach us via email
                        </div>
                        <div className="center-text-container-email">
                            {companyDetails?.Email}
                        </div>
                    </div>
                </div></div></Popup>
    )
}
export default SupportModal